import React from 'react';

export default function RightImageText() {
    return (
        <>
            <div className='it-sol-con'>
                <div className="row g-0">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-md-none">
                        <div className='it-sol-img-con'>
                            <img src='/images/service/it-solution.png' alt="lurantech solutions" />
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-7">
                        <div className='it-sol-title'>Tailored IT Solutions for Your Success</div>
                        <div className='it-sol-description'>
                           <p>In today's digital age, every business has unique needs and challenges. At Lurantech, we understand that one-size-fits-all solutions simply don't cut it. That's why we specialize in providing tailored IT solutions designed to meet the specific requirements of your website, CMS, and e-commerce platforms. Whether you're looking to enhance user experience, streamline operations, or drive more conversions, our solutions are crafted to help you succeed.</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-5 d-none d-md-block">
                        <div className='it-sol-img-con'>
                            <img src='/images/service/it-solution.png' alt="lurantech solutions" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
